import { Injectable, OnDestroy } from '@angular/core';
import { ApiService } from '../../services/common/api.service';
import { BehaviorSubject, Subject } from 'rxjs';

import { myJqxTreeItem } from '../../model/tree';

@Injectable()
export class DanhMucService implements OnDestroy {

  ngOnDestroy(): void {
    this._navItemSource.complete();
    this._navItemSource.unsubscribe();
  }

  private _navItemSource = new BehaviorSubject<any>(0);
  //private _navItemSource = new Subject();
  // Observable navItem stream
  navItem$ = this._navItemSource.asObservable();
  // service command
  changeNav(number) {
    this._navItemSource.next(number);
  }

  private _reloadNav = new Subject();
  reloadNav$ = this._reloadNav.asObservable();
  reLoadNav() {
    this._reloadNav.next(0);
  }

  private _loadCusDone = new BehaviorSubject<any>(0);
  loadCusDone$ = this._loadCusDone.asObservable();
  loadCusDone() {
    this._loadCusDone.next(0);
  }


  public listDienLuc: any = Array();
  public listData: any = [];
  APIURL = "api/Directories"
  APIURL_GetDanhMucTram = "api/Directories/GetDanhMucTram"
  APIURL_Chung = "api/ExcuteOracle"
  constructor(public api: ApiService) {
  }
  //public getAllDienLuc(idDanhMuc) {
  //  var param = {
  //    "config": '{"namesql":"PKG_DANHMUC.P_LAYDS_DANHMUC","connstr":"Amiss42"}',
  //    "para": '{"v_danhmucid":"' + idDanhMuc + '"}'
  //  };
  //  return this.api.Excute(this.APIURL, param);
  //}

  public getAllTram(idDanhMucCha) {
    var param = {
      "config": '{"namesql":"PKG_DANHMUC.P_LAYDS_TATCA_DANHMUC","connstr":"Amiss42"}',
      "para": '{"v_danhmucid":"' + idDanhMucCha + '"}'
    };
    return this.api.Excute(this.APIURL, param);
  }

  public getDienluc(idDanhMucCha) {
    var param = {
      "config": '{"namesql":"PKG_DANHMUC.P_LAYDS_DIENLUC","connstr":"Amiss42"}',
      "para": '{"v_danhmucid":"' + idDanhMucCha + '"}'
    };
    return this.api.Excute(this.APIURL, param);
  }

  public getKhachHangByDanhMucID(idDanhMuc, maTaiKhoan) {
    var param = {
      "config": '{"namesql":"PKG_KHACHHANG.P_LAYDS_KHACHHANG","connstr":"Amiss42"}',
      "para": '{"v_danhmucid":"' + idDanhMuc + '","v_mataikhoan":"' + maTaiKhoan + '"}'
    };
    return this.api.Excute('api/ExcuteOracle', param);
  }

  public getKhachHangPhanQuyen(idDanhMuc) {
    var param = {
      "config": '{"namesql":"PKG_KHACHHANG.P_LAYDS_KHACHHANG_PHANQUYEN","connstr":"Amiss42"}',
      "para": '{"v_danhmucid":"' + idDanhMuc + '"}'
    };
    return this.api.Excute('api/ExcuteOracle', param);
  }

  public getDanhmuc(danhmucid, typenode, mataikhoan, demsoluong) {
    var param = {
      "config": '{"namesql":"' + (demsoluong == 1 ? "PKG_DANHMUC_3PHA.P_LAYDS_DANHMUC" : "PKG_DANHMUC.P_LAYDS_DANHMUC_NOCOUNT") + '","connstr":"Amiss42"}',
      "para": '{"v_danhmucid":"' + danhmucid + '", "v_typenode": "' + typenode + '", "v_mataikhoan":"' + mataikhoan + '"}'
    };
    return this.api.Excute('api/ExcuteOracle', param);
  }


  public getDanhMucByMaTaiKhoan(danhmucid, typenode) {
    var param = {
      "config": '{"namesql":"PKG_DANHMUC.P_LAYDS_DANHMUC_MATAIKHOAN"}',
      "para": '{"v_danhmucid":"' + danhmucid + '", "v_typenode": "' + typenode + '"}'
    };
    return this.api.Excute('api/ExcuteOracle', param);
  }

  public getDanhMucTram(idDanhMucCha) {
    var param = {
      "config": '{"namesql":"PKG_DANHMUC.P_LAYDS_TATCA_DANHMUC","connstr":"Amiss42"}',
      "para": '{"v_danhmucid":"' + idDanhMucCha + '"}'
    };
    return this.api.Excute(this.APIURL_GetDanhMucTram, param);
  }
  public getMaDiemDo(makhachhang) {
    var param = {
      "config": '{"namesql":"PKG_TAIKHOAN.P_LAYDS_DIEMDO","connstr":"Amiss42"}',
      "para": '{"v_makhachhang":"' + makhachhang + '"}'
    };
    return this.api.Excute('api/ExcuteOracle', param);
  }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/common/danhmuc.service.ts